module.exports = new __parcel__URL__("tracking-ghg-cycles--cover.8b41e9ce.jpeg").toString();